import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/Stores/auth-v2-store';

const DASHBOARD_PERMISSIONS = [
  'dashboard.view_all',
  'dashboard.view_contracts',
  'dashboard.view_revenue',
  'dashboard.view_sav_claims',
  'dashboard.view_sav_amounts',
  'dashboard.view_provision',
  'dashboard.view_encaissements',
  'dashboard.view_synthese',
  'dashboard.view_upsell',
];

export const DefaultRedirect = () => {
  const { hasPermission } = useAuthStore();
  const hasDashboard = DASHBOARD_PERMISSIONS.some(p => hasPermission(p));
  return <Navigate to={hasDashboard ? '/dashboard' : '/contracts'} replace />;
};
